export default {"src":"/_next/static/image/public/images/down_arrow_white.030c9a10f38b2108d72507f1f98e10ba.svg","height":6,"width":11};